import { NO_NAME_LABEL } from '@app/constants';

// Заглушка вместо инициалов: из «Без имени» нельзя строить «Б. И.»
// (issue/11538).
export const NO_NAME_INITIALS = '—';

export const getLeadInfoInitials = (name: string): string => {
  if (name === NO_NAME_LABEL) return NO_NAME_INITIALS;

  const words = name.trim().split(/\s+/);
  return words
    .slice(0, 2)
    .map((w) => `${w.charAt(0).toUpperCase()}.`)
    .join(' ');
};
